import React, { useEffect, useState } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

import PageHeader from '../../../Components/UI/PageHeader'
import NavTabs from '../../../Components/core/profile/NavTabs'

import classes from "./profile.module.css"

const Profile = () => {
    const [activeTab ,setActiveTab] = useState("profile")
    const location = useLocation()
    const navigate = useNavigate()

    useEffect(()=>{
      const path = location.pathname.split("/user/").pop()
      setActiveTab(path)
    },[location])

    const handleActiveTab=(tab ,route)=>{
        setActiveTab(tab)
        navigate(route)
    }
  return (
    <div className={classes.container}>
      <PageHeader title="صفحة البروفايل"  />
      <div className={classes.RowTabs}>
      <NavTabs handleActiveTab={handleActiveTab} activeTab={activeTab}/>
      <div className={classes.TabsContent}>
      <Outlet/>
      </div>
    </div>
  </div>
  )
}

export default Profile